module.exports = __webpack_public_path__ + "img/covers-05.af61c829.png";